import { NgModule, Component } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { WishlistComponent } from './components/wishlist/wishlist.component';
import { HeaderComponent } from './components/header/header.component';
import { TestComponent } from './components/test/test.component';
import { ShopComponent } from './components/shop/shop.component';
import { SingleproductComponent } from './components/singleproduct/singleproduct.component';
import { CartComponent } from './components/cart/cart.component';
import { CheckoutComponent } from './components/checkout/checkout.component';
import { MarqueComponent } from './components/marque/marque.component';
import { ContactComponent } from './components/contact/contact.component';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { ForgetPasswordComponent } from './components/auth/forget-password/forget-password.component';
import { AccountComponent } from './components/account/account.component';
import { AccountordersComponent } from './components/accountorders/accountorders.component';
import { AccountdetailsComponent } from './components/accountdetails/accountdetails.component';
import { AccountinfosComponent } from './components/accountinfos/accountinfos.component';
import { FooterComponent } from './components/footer/footer.component';
import { SubcategorieComponent } from './components/subcategorie/subcategorie.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    WishlistComponent,
    HeaderComponent,
    TestComponent,
    ShopComponent,
    SingleproductComponent,
    CartComponent,
    CheckoutComponent,
    MarqueComponent,
    ContactComponent,
    LoginComponent,
    RegisterComponent,
    ForgetPasswordComponent,
    AccountComponent,
    AccountordersComponent,
    AccountdetailsComponent,
    AccountinfosComponent,
    FooterComponent,
    SubcategorieComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule

  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
